export const MAKE_ORDER_BOOK_EMPTY = 'MAKE_ORDER_BOOK_EMPTY';

export const FETCH_ALL_ORDER_BOOK = 'FETCH_ALL_ORDER_BOOK';
export const FETCH_ALL_ORDER_BOOK_FAILED = 'FETCH_ALL_ORDER_BOOK_FAILED';
export const FETCH_ALL_ORDER_BOOK_SUCCEED = 'FETCH_ALL_ORDER_BOOK_SUCCEED';

export const FETCH_BUY_ORDER_BOOK = 'FETCH_BUY_ORDER_BOOK';
export const FETCH_BUY_ORDER_BOOK_FAILED = 'FETCH_BUY_ORDER_BOOK_FAILED';
export const FETCH_BUY_ORDER_BOOK_SUCCEED = 'FETCH_BUY_ORDER_BOOK_SUCCEED';

export const FETCH_SELL_ORDER_BOOK = 'FETCH_SELL_ORDER_BOOK';
export const FETCH_SELL_ORDER_BOOK_FAILED = 'FETCH_SELL_ORDER_BOOK_FAILED';
export const FETCH_SELL_ORDER_BOOK_SUCCEED = 'FETCH_SELL_ORDER_BOOK_SUCCEED';

export const CLICK_ORDER_BOOK_BUY = 'CLICK_ORDER_BOOK_BUY';
export const CLICK_ORDER_BOOK_SELL = 'CLICK_ORDER_BOOK_SELL';
